'use strict';

const form = document.getElementById('modalForm');

form.onsubmit = modalFormSubmitHandler;

function modalFormSubmitHandler(e) {
  e.preventDefault();
  const modalFormContactName = document
    .querySelector('#modalFormName')
    .value.trim();
  const modalFormContactEmail = document
    .querySelector('#modalFormEmail')
    .value.trim();
  const modalFormContactPhone = document
    .querySelector('#modalFormPhone')
    .value.trim();
  const modalFormContactDate = document
    .querySelector('#modalFormDate')
    .value.trim();
  const modalFormContactPL = document
    .querySelector('#modalFormPickupLocation')
    .value.trim();
  const modalFormContactDL = document
    .querySelector('#modalFormDropLocation')
    .value.trim();

  sendEmail(
    modalFormContactName,
    modalFormContactEmail,
    modalFormContactPhone,
    modalFormContactDate,
    modalFormContactPL,
    modalFormContactDL
  );

  document.querySelector('#modalFormName').value = '';
  document.querySelector('#modalFormEmail').value = '';
  document.querySelector('#modalFormPhone').value = '';
  document.querySelector('#modalFormDate').value = '';
  document.querySelector('#modalFormPickupLocation').value = '';
  document.querySelector('#modalFormDropLocation').value = '';
}

function sendEmail(
  modalFormContactName,
  modalFormContactEmail,
  modalFormContactPhone,
  modalFormContactDate,
  modalFormContactPL,
  modalFormContactDL
) {
  Email.send({
    Host: 'smtp.gmail.com',
    Username: 'flexiblebangaloreairporttaxi@gmail.com',
    Password: 'cqopczehbipixiwz',
    To: 'flexiblebangaloreairporttaxi@gmail.com',
    From: modalFormContactEmail,
    Subject: 'New Booking Request Received',
    Body: `Dear Admin,<br><br>Greeting for the day!<br><br> You have received new booking request on your website. Please find the below details for the same: <br><br> Name : ${modalFormContactName} <br> Email: ${modalFormContactEmail} <br> Mobile Number: ${modalFormContactPhone} <br> Booking Date: ${modalFormContactDate} <br> Pickup Location: ${modalFormContactPL} <br> Drop Location: ${modalFormContactDL}`,
  }).then((message) => alert('mail sent successfully'));
}
